import React from 'react';
import PropTypes from 'prop-types';

class Tab extends React.Component {
    render () {
        return (
            <article>
                { this.props.children }
            </article>
        )
    }

    static propTypes = {
        title: PropTypes.string.isRequired,
        category: PropTypes.string
    }
}

export default Tab;
